import { render } from "./setMod.vue?vue&type=template&id=4a86717a&scoped=true"
import script from "./setMod.vue?vue&type=script&lang=js"
export * from "./setMod.vue?vue&type=script&lang=js"

import "./setMod.vue?vue&type=style&index=0&id=4a86717a&scoped=true&lang=css"

import exportComponent from "D:\\work\\sckj\\wwei\\ww-vue\\wwei_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a86717a"]])

export default __exports__